var _defs, _metadata, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTopbarLogo = function SvgTopbarLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    dc: "http://purl.org/dc/elements/1.1/",
    cc: "http://creativecommons.org/ns#",
    rdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    svg: "http://www.w3.org/2000/svg",
    width: "6mm",
    height: "6.5mm",
    viewBox: "0 0 24.444855 26.541573",
    fill: "#ffffff",
    id: "svg170",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs164"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata167"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-90.744661,-125.9253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g54",
    transform: "matrix(0.26458333,0,0,0.26458333,-2.2008157,11.973126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 416.16,504.3 c -1.83,3.83 -4.34,9.68 -6.23,14.83 -0.95,-2.78 -2.11,-7.85 0.26,-15.31 3.8,-11.96 12.57,-18.98 19.18,-28.67 5.7,-8.35 7.74,-13.41 8.37,-15.23 -5.67,3.22 -14.02,7.99 -18.65,10.77 -18.29,10.21 -18.47,14.45 -18.47,28.01 V 531 c 0,0 21.46,-12.42 30.73,-17.72 12.32,-7.34 12.23,-18.1 12.23,-21.13 0,-3.57 0.06,-21.58 0.1,-30.53 -1.77,3.85 -2.62,6.7 -7.83,14.94 -4.86,7.67 -14.41,16.73 -19.69,27.74 z",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 360.36,469.6 c 0.98,4.32 4.98,12.15 7.2,15.96 4.01,6.88 12.02,15.62 16.9,21.45 2.9,3.46 7.38,10.37 9.88,16.37 v -24.66 c 0,-13.56 -0.08,-17.09 -18.22,-28.15 -7.46,-4.48 -24.83,-13.95 -24.83,-13.95 0,0 0,30.76 0,35.56 0,3.03 -0.06,13.63 12.26,20.97 6.79,3.94 19.84,11.58 26.56,15.47 -5.73,-16.02 -21.52,-28.26 -26.54,-37.86 -3.52,-6.75 -5.22,-15.5 -3.21,-21.16 z",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 440.49,451.19 -27.72,-16.14 c -10.28,-5.91 -20.57,-5.8 -30.74,0.22 -5.36,3.19 -16.59,9.53 -22.98,13.12 4.18,0.59 10.7,0.81 15.53,0.54 8.76,-0.49 23.03,-4.33 31.2,-3.85 7.05,0.42 12.52,3.19 17.01,7.88 -6.6,-1.56 -11.27,-1.7 -15.99,-1.74 -11.78,-0.1 -19.14,2.67 -27.41,3.44 -8.53,0.8 -17.26,0.16 -18.98,-0.13 7.3,4.23 18.94,10.96 21.73,12.58 11.92,7.11 19.91,6.35 30.52,0.11 9.23,-5.39 27.83,-16.03 27.83,-16.03 z",
    id: "path34"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTopbarLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/topbar-logo.6de4cd32.svg";
export { ForwardRef as ReactComponent };